import React from "react";
import { PlusCircle } from "lucide-react";

export default function AdunitStats({ total, active }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
        <div className="flex items-center justify-between">
          <h3 className="text-gray-500 font-medium">Total AdUnits</h3>
          <div className="p-3 rounded-lg bg-blue-100 text-blue-600">
            <PlusCircle className="w-6 h-6" />
          </div>
        </div>
        <p className="text-3xl font-bold mt-2">{total}</p>
      </div>
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100">
        <div className="flex items-center justify-between">
          <h3 className="text-gray-500 font-medium">Active AdUnits</h3>
          <div className="p-3 rounded-lg bg-emerald-100 text-emerald-600">
          </div>
        </div>
        <p className="text-3xl font-bold mt-2">{active}</p>
      </div>
    </div>
  );
}
